import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-linen" data-id="element-65">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-66">
        <FadeIn data-id="element-67">
          <div className="bg-white rounded-3xl shadow-warm p-8 md:p-16 text-center border border-terracotta/10 relative overflow-hidden" data-id="element-68">
            {/* Decorative corners */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-terracotta/20 rounded-tl-3xl m-4" data-id="element-69"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-terracotta/20 rounded-br-3xl m-4" data-id="element-70"></div>

            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-71">
              Recupera tu paz mental y el control de tus tardes.
            </h2>

            <p className="text-xl text-warmgray mb-10 max-w-2xl mx-auto" data-id="element-72">
              Deja de pagar el "impuesto al cansancio" con comida a domicilio y
              frustración. Obtén el método completo "Hogar en Autopiloto" hoy
              mismo.
            </p>

            <div className="mb-10" data-id="element-73">
              <span className="block text-sm font-semibold text-terracotta uppercase tracking-wider mb-2" data-id="element-74">
                Inversión única
              </span>
              <span className="text-6xl font-serif text-charcoal" data-id="element-75">
                $6.36{' '}
                <span className="text-2xl text-warmgray font-sans" data-id="element-76">USD</span>
              </span>
            </div>

            <Button href="https://hogarenautopiloto.tucasareset.com/" className="w-full md:w-auto text-lg px-10 py-5 shadow-warm mb-6" data-id="element-77">
              ¡QUIERO MI HOGAR EN AUTOPILOTO AHORA!
            </Button>

            <p className="text-sm text-warmgray flex items-center justify-center" data-id="element-78">
              <svg className="w-4 h-4 mr-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-79">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-80" />
              </svg>
              Acceso inmediato tras la compra. Comienza hoy mismo a liberar tu
              mente.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}